export default __webpack_public_path__ + "static/banner-circuit-web-c3b97a956a5486a451ce704475995c5c.svg";